import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 px-6 bg-dark relative overflow-hidden" data-id="element-154">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/10 via-dark to-dark" data-id="element-155"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="bg-dark-card/50 backdrop-blur-sm border border-gold/20 p-10 md:p-16 rounded-2xl" data-id="element-157">
          <Quote className="w-12 h-12 text-gold/40 mx-auto mb-6" data-id="element-158" />
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed italic" data-id="element-159">
            "En solo 7 días, pasarás de ser alguien que 'mira los videos de
            Dubái con ganas' a ser la persona que todos graban mientras cortas
            tu propia creación crujiente y perfecta."
          </p>
        </motion.div>
      </div>
    </section>;
}